module.exports = __webpack_public_path__ + "static/img/200293.56d0f380.png";